module.exports = new __parcel__URL__("high.19a3b29d.svg").toString();